<template>
  <div class="service-list-qs" :class="{ 'hp-hide': scrollDirection === 1 }">
    <!-- 第二层tab -->
    <ul
      class="two-floor-tabs"
      :style="{ top: zxStickOffsetTop + 'px' }"
      v-show="showQsTabs"
    >
      <li
        class="two-tab"
        :class="{
          active: currentQsTabIndex === index
        }"
        v-for="(tab, index) in qsTabList"
        :key="tab.name"
        @click="onQsTabChange(tab, index)"
      >
        {{ tab.title }}
      </li>
    </ul>

    <qingsuPanel
      v-if="isProvideVoice || isProvideText"
      ref="QingsuPanel"
      :tabData="{ name: 'consult', title: '基础' }"
    ></qingsuPanel>

    <upgradePkgs
      v-if="activities.length"
      :activities="activities"
      ref="UpgradePkgs"
      :tabData="{ name: 'pkgs', title: '精选' }"
    />

    <evaluatePanel
      v-if="rateList.length"
      ref="evaluatePanel"
      :tabData="{ name: 'rate', title: '评价' }"
      @toRateTab="toRateTab"
    />

    <goodAtPanel
      v-if="expertise.length || therapyFeature.length"
      ref="GoodAt"
      :expertise="expertise"
      :therapyFeature="therapyFeature"
      :tabData="{ name: 'goodat', title: '擅长' }"
    ></goodAtPanel>

    <authorDescPanel
      v-if="introduction"
      ref="AuthorDesc"
      :tabData="{ name: 'desc', title: '简介' }"
      :introduction="introduction"
    ></authorDescPanel>

    <qsStylePanel
      v-if="listeningStyle.length"
      ref="qsStyle"
      :tags="listeningStyle"
      :tabData="{ name: 'qsStyle', title: '风格' }"
    ></qsStylePanel>

    <certificationPanel
      ref="Certification"
      :tabData="{ name: 'cert', title: '资质' }"
    ></certificationPanel>
  </div>
</template>

<script>
import qingsuPanel from 'component/platform/homepage/qingsuTeacher/qingsuPanel.vue'
import upgradePkgs from 'component/platform/homepage/qingsuTeacher/upgradePkgs.vue'
import evaluatePanel from 'component/platform/homepage/qingsuTeacher/evaluatePanel.vue'
import certificationPanel from 'component/platform/homepage/qingsuTeacher/certificationPanel.vue'
import goodAtPanel from 'component/platform/homepage/qingsuTeacher/goodAtPanel.vue'
import qsStylePanel from 'component/platform/homepage/qingsuTeacher/qsStylePanel.vue'
import authorDescPanel from 'component/platform/homepage/consultTeacher/authorDescPanel.vue'
import { getOffsetTop } from 'lib/tools/domUtil.js'

export default {
  components: {
    authorDescPanel,
    goodAtPanel,
    certificationPanel,
    qingsuPanel,
    upgradePkgs,
    evaluatePanel,
    qsStylePanel
  },
  props: {
    showQsTabsDistance: Number,
    scrollDirection: Number
  },
  data() {
    return {
      panelRefs: [],
      qsTabList: [],
      showQsTabs: false,
      currentQsTabIndex: -1
    }
  },
  computed: {
    qingsuService() {
      return this.$store.state.homepage.qingsuService
    },
    rateList() {
      return this.$store.state.homepage.qingsuRateInfo.list
    },
    distance() {
      return this.$store.state.homepage.distance
    },
    zxStickOffsetTop() {
      return this.$store.getters['homepage/zxStickOffsetTop']
    },
    introduction() {
      const { info } = this.qingsuService
      return info ? info.introduction : ''
    },
    activities() {
      return this.qingsuService.activities || []
    },
    isProvideVoice() {
      const { is_provide_voice } = this.qingsuService.info || {}
      return is_provide_voice || ''
    },
    isProvideText() {
      const { is_provide_text } = this.qingsuService.info || {}
      return is_provide_text || ''
    },
    expertise() {
      const { categorys } = this.qingsuService.info || {}
      return categorys || []
    },
    listeningStyle() {
      const { listening_style } = this.qingsuService.info || {}
      return listening_style ? listening_style.split(',') : []
    },
    therapyFeature() {
      const { therapy_feature = [] } = this.qingsuService.info || {}
      return therapy_feature.length
        ? therapy_feature.join('，').split('，')
        : []
    }
  },
  watch: {
    panelRefs: {
      handler() {
        this.qsTabList = this.panelRefs
          .map(v => v.$attrs && v.$attrs.tabData)
          .filter(v => !!v)
      },
      immediate: true
    }
  },
  mounted() {
    this.scrollHander = this._scrollHander.bind(this)
    window.addEventListener('scroll', this.scrollHander)
    this.$nextTick(() => {
      this.getRefs()
    })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollHander)
  },
  methods: {
    onQsTabChange(tab, index) {
      this.currentQsTabIndex = index
      // 点击到指定板块
      let oh = this.distance.headerHeight + this.distance.zxNavHeight
      if (this.scrollDirection !== 1) {
        oh += this.distance.navHeight
      }
      const refs = this.getRefs()
      const top = getOffsetTop(refs[index].$el)

      // 300毫秒内，不获取滚动方向，不触发_scrollHandler
      window.yxl = window.yxl || {}
      window.yxl.ignoreScrollDirection = true
      window.yxl.ignoreScrollHandler = true
      setTimeout(() => {
        window.yxl.ignoreScrollDirection = false
        window.yxl.ignoreScrollHandler = false
      }, 300)

      // 加多5px,防止定位不足
      const distance = top - oh + 5
      document.documentElement.scrollTop = distance
      document.body.scrollTop = distance
    },
    // 父组件、本组件都会调用。
    getRefs() {
      const {
        QingsuPanel,
        UpgradePkgs,
        evaluatePanel,
        GoodAt,
        AuthorDesc,
        qsStyle,
        Certification
      } = this.$refs

      this.panelRefs = [
        QingsuPanel,
        UpgradePkgs,
        evaluatePanel,
        GoodAt,
        AuthorDesc,
        qsStyle,
        Certification
      ].filter(item => !!item)

      return this.panelRefs.filter(ref => ref.$el.nodeType === 1) // 只取元素节点
    },
    _scrollHander() {
      const t = document.documentElement.scrollTop || document.body.scrollTop
      this.showQsTabs = t > this.showQsTabsDistance

      if (window.yxl && window.yxl.ignoreScrollHandler === true) {
        return
      }
      const oh =
        this.distance.headerHeight +
        this.distance.navHeight +
        this.distance.zxNavHeight

      const refs = this.getRefs()
      let index = -1
      // 判断当前哪个区块高亮
      for (let i = 0; i < refs.length; i++) {
        let ref = refs[i]
        const { top, bottom } = ref.$el.getBoundingClientRect()
        if (top <= oh && bottom > oh) {
          index = i
          break
        }
      }
      this.currentQsTabIndex = index
    },
    toRateTab() {
      this.$emit('toRate')
    }
  }
}
</script>

<style lang="scss" scoped>
.service-list-qs {
  .two-floor-tabs {
    overflow: scroll;
    transition: transform 0.2s linear;
    display: flex;
    align-items: center;
    height: 88px;
    position: fixed;
    left: 50%;
    background-color: #fff;
    width: calc(10rem - 60px);
    transform: translate3d(-50%, 0, 0);
    z-index: $hp_zIndex_tababr;
    box-sizing: border-box;
    .two-tab {
      word-break: keep-all;
      padding: 0 16px;
      height: 60px;
      background: #f3f4f5;
      border-radius: 40px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #6c798c;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 20px;
      &:last-child {
        margin-right: 0;
      }
      &.active {
        background: #ff745b;
        color: #ffffff;
      }
    }
  }
  .to-rate {
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffa202;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 40px;
    img {
      width: 14px;
      height: 14px;
      object-fit: cover;
      margin-left: 6px;
    }
  }
}
</style>
